import {Component, OnInit, Input} from '@angular/core';
import { BtDatasourcesModel } from '../bt-datasources.model';
import { MatDialog } from '@angular/material/dialog';
import { MDBtDatasourcePickerComponent } from '../md-datasources-picker/md-bt-datasource-picker.component';

@Component({
    selector: 'bt-datasources',
    templateUrl: './bt-datasources.component.html',
    styleUrls: ['./bt-datasources.component.scss']
})
export class BtDatasourcesComponent implements OnInit {
    @Input() model: BtDatasourcesModel;

    constructor(
        private dialog: MatDialog
    ) {
    }

    ngOnInit() {
    }

    doOpenDatasourcesPickerDialog() {
        this.dialog.open(MDBtDatasourcePickerComponent);
    }
}